import OIDCSignInCallback from './OIDCSignInCallback';

export default OIDCSignInCallback;
